module.exports = __webpack_public_path__ + "img/process.8fc4661b.png";